import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {ContentBlockHeader} from '@growcloud-io/dc/components/surface/ContentBlockHeader';
import {newColumnStack} from "@growcloud-io/gcio-commons/common/utils/UiUtils";
import {getCaseStudiesData} from "./data/FrontPageData";

const CaseStudyTemplate = ({problem,strategy}) => {
  return (
    <Stack direction={'column'} sx={newColumnStack()}>
      <Box>
        <Typography variant={'h4'} color="textSecondary">{'PROBLEM'}</Typography>
      </Box>
      <Box>
        <Typography variant={'subtitle1'} color="textSecondary">{problem}</Typography>
      </Box>
      <Box>
        <Typography variant={'h4'} color="textSecondary">{'STRATEGY'}</Typography>
      </Box>
      <Box>
        <Typography variant={'subtitle1'} color="textSecondary">{strategy}</Typography>
      </Box>
    </Stack>
  )
}

const getCaseStudyData = (caseStudiesData, slug) => {
  for(let caseStudyData of caseStudiesData){
    for(let caseStudyItem of caseStudyData.items){
      if(caseStudyItem.slug === slug) {
        return caseStudyItem;
      }
    }
  }
  return null;
}
export const CaseStudyPage = ({}) => {
  const urlComponents = window.location.href.split('/')
  const slug = urlComponents[urlComponents.length - 1];
  const caseStudiesData = getCaseStudiesData();
  const caseStudyData = getCaseStudyData(caseStudiesData, slug);
  const caseStudy = {problem:'Problem statement',strategy:'Strategy statement',...caseStudyData}
  return (
    <Stack direction={'column'} sx={newColumnStack()}>
      <ContentBlockHeader
        PageTitle={caseStudyData.label}
        SubHeader={''}
        Alignment="left"
      />
      <CaseStudyTemplate
        problem={caseStudy.problem}
        strategy={caseStudy.strategy}
      />
    </Stack>
  );
}